import http from './http'
import Resource from './resource'

const path = 'admin/users'

class Users extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const UsersRequest = new Users(http)

export default UsersRequest
